/**
 *
 * http配置
 *
 */

import axios from "axios";
import { Message } from "element-ui";
import errorCode from "@/const/errorCode";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { objKeySort } from "@/util/ajaxsign";
import { urls } from '@/config/env';
// 超时时间
axios.defaults.timeout = 30000;
// 跨域请求，允许保存cookie
axios.defaults.withCredentials = true;
NProgress.configure({ showSpinner: false }); // NProgress Configuration
console.log(urls)
// HTTPrequest拦截
axios.interceptors.request.use(
 
  config => {
    NProgress.start(); // start progress bar
    config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    if (config.url != "127.0.0.1:8000") {
     // config.url = "http://192.168.1.211/api" + config.url;
      config.url = urls.apiLink + config.url;
      
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// HTTPresponse拦截
axios.interceptors.response.use(
  data => {
    NProgress.done();
    if(data.data&&data.data.code){
      const code = data.data.code;
      if(code===200){
        return data;
      }else if(code===408){
        Message({
          message: data.data.msg,
          type: "warning"
        });
        sessionStorage.clear();
        window.location.href = "/index/login.html";
        return null;
      }else{
        if(data.data.msg){
          Message({
            message: data.data.msg,
            type: "warning"
          });
        }
        return data;
      }
    }else{
      return data;
    }
  },
  error => {
    NProgress.done();
    let errMsg = {
      status: "",
      error: "",
      message: ""
    };
    if(error.code!=12){
      if (error.response == null) {
        errMsg.message = "请求无返回内容";
      } else {
        errMsg = error.response.data;
      }
    }

    const code = errMsg.code || errMsg.status || errMsg.error;
    let errMsgOut = "";
    if (errMsg === "" || errMsg.msg === "error" || code === "401" || parseInt(code) === 403) {
      errMsgOut = errMsg.message;
    }

    if (errMsg.message === undefined && errMsg.error === undefined) {
      errMsgOut = errorCode[code] || errorCode["default"];
    } else if (errMsg.message != null) {
      errMsgOut = errMsg.message;
    } else {
      errMsgOut = errMsg.error_description;
    }

    if(error.code !=12){
      Message({
        message: errMsgOut,
        type: "error"
      });
      return Promise.reject(new Error(error));
    }
  }
);

export default axios;
